import React, { Fragment, useRef, useState } from 'react';
// import MobileHeaderTopLinks from "./MobileHeaderTopLinks";
import QuickSearchButton from './QuickSearchButton';
import QuickSearchMobile from './QuickSearchMobile';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null, depth = 0 }) => {
  const menuRef = useRef(null);
  const hoverTimeoutRef = useRef(null);
  const [openMegaMenuKey, setOpenMegaMenuKey] = useState(null);
  const logo = useSelector((state) => state.navigation.logo);
  const toggleMenu = () => {
    menuRef.current.classList.toggle('navbar__menu--show');

    if (depth === 0) {
      document.getElementById('menu-overlay').classList.toggle('hidden');
    }
  };

  const isDesktop = () => window.matchMedia('(min-width: 768px)').matches;
  const getMenuItemKey = (link) => link.url || link.name;

  const handleMegaMenuMouseEnter = (link) => {
    if (depth !== 0 || !link?.links?.length || !isDesktop()) {
      return;
    }

    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    setOpenMegaMenuKey(getMenuItemKey(link));
  };

  const handleMegaMenuMouseLeave = (link) => {
    if (depth !== 0 || !link?.links?.length || !isDesktop()) {
      return;
    }

    clearTimeout(hoverTimeoutRef.current);

    if (openMegaMenuKey === getMenuItemKey(link)) {
      hoverTimeoutRef.current = setTimeout(() => {
        const navbar = document.getElementById('navbar');

        if (navbar?.matches(':hover')) {
          return;
        }

        setOpenMegaMenuKey(null);
      }, 150);
    }
  };
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';

  const hasChildrenClass = links.length > 0 ? 'has-children' : null;

  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;

  const isCurrentLink = window.location.pathname === contentLink?.url;

  function linkWrapper(elements) {
    if (depth === 1) {
      return <Fragment>{elements}</Fragment>;
    }

    return <Fragment>{elements}</Fragment>;
  }

  return (
    <Fragment>
      {!contentLink ? (
        <a
          className={
            'navbar__link--block navbar__icon--menu navbar__icon' +
            ' navbar__link--depth-2' +
            depth
          }
          onClick={toggleMenu}
        ></a>
      ) : (
        <Fragment>
          <a
            className={
              `navbar__link ${selectedClass} ${
                isCurrentLink ? 'navbar__link--active' : ''
              } ${hasChildrenClass || ''} ${additionClass || ''}` +
              ' navbar__link--depth-' +
              depth
            }
            href={contentLink.url || '#'}
          >
            <span dangerouslySetInnerHTML={{ __html: contentLink.name }} />
            {links.length > 0 && depth === 1 && (
              <i className="navbar__icon--chevron-down navbar__icon--link" />
            )}
          </a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 &&
        linkWrapper(
          <ul
            className={'navbar__menu navbar__menu--depth-' + depth}
            ref={menuRef}
          >
            {depth > 0 && contentLink && (
              <div
                className={`navbar__menu-header navbar__menu-header--depth-${depth}`}
              >
                <i
                  className="navbar__icon--caret-left navbar__icon"
                  onClick={toggleMenu}
                />
                <span
                  className="navbar__title"
                  onClick={toggleMenu}
                  dangerouslySetInnerHTML={{
                    __html: contentLink.name,
                  }}
                ></span>
              </div>
            )}

            {depth === 0 && (
              <li className="lg:hidden">
                <div className="quick-search__mobile-container">
                  <QuickSearchMobile />
                </div>
              </li>
            )}

            <Fragment>
              {links.length > 0 &&
                links.map((link) => (
                  <li
                    key={`navbar-item-${link.name}-depth-${depth}`}
                    className={
                      'navbar__item navbar__item ' +
                      ('navbar__item--' + link.numberOfColumns + '-columns') +
                      (link.hasRightBorder
                        ? ' navbar__item--has-right-border'
                        : '') +
                      (link.callToAction || link.featuredProduct
                        ? ' navbar__item--hidden-mobile'
                        : '') +
                      (' navbar__item--depth-' + depth) +
                      (depth === 0 &&
                      openMegaMenuKey === getMenuItemKey(link) &&
                      (link.links || []).length > 0
                        ? ' navbar__item--mega-open'
                        : '')
                    }
                    onMouseEnter={() => handleMegaMenuMouseEnter(link)}
                    onMouseLeave={() => handleMegaMenuMouseLeave(link)}
                  >
                    {hasNameOrChildren(link) && (
                      <NavigationItem
                        links={link.links}
                        contentLink={link}
                        depth={depth + 1}
                      />
                    )}

                    {link.callToAction && (
                      <div
                        className={
                          'navbar__cta-item' +
                          (link.callToAction.image
                            ? ' navbar__cta-item--with-image'
                            : '')
                        }
                      >
                        {link.callToAction.image && (
                          <>
                            <img
                              className="navbar__cta-item-image"
                              src={link.callToAction.image}
                              alt=""
                            />
                            <div className="navbar__cta-item-overlay"></div>
                          </>
                        )}

                        <div className="navbar__cta-item-content">
                          <p className="navbar__cta-item-text ">
                            {link.callToAction.text}
                          </p>
                          <a
                            href={link.url}
                            className=" button button--primary navbar__cta-item-button"
                          >
                            {link.callToAction.buttonText}
                          </a>
                        </div>
                      </div>
                    )}

                    {link.featuredProduct && (
                      <a
                        className="navbar__featured-product"
                        href={link.featuredProduct.url}
                      >
                        <p className="navbar__featured-product-title">
                          {link.featuredProduct.title}
                        </p>

                        <img
                          className="navbar__featured-product-image"
                          src={link.featuredProduct.imageUrl}
                          alt=""
                        />

                        <p className="navbar__featured-product-name">
                          {link.featuredProduct.name}
                        </p>
                      </a>
                    )}
                  </li>
                ))}
              {/*{depth === 0 && <li><MobileHeaderTopLinks/></li>}*/}
            </Fragment>
          </ul>
        )}
    </Fragment>
  );
};

export default NavigationItem;
